export default __webpack_public_path__ + "static/yoga-lesson-7e60ec877c15a255e837324e1dadea0c.jpg";